import FleetModal from '@/libs/antd/components/Modal';
import { getFRMCallReportDetailWithId } from '@/libs/fleet-api/services/visit-reports';
import { useQuery } from '@tanstack/react-query';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { FC, useState } from 'react';
import CallReportPdfDetail, {
	CallReportPdfData,
} from '../pdf/CallReportPdfDetail';

const downloadPDF = async (el: HTMLElement, filename: string) => {
	const canvas = await html2canvas(el, {
		allowTaint: true,
		logging: true,
		useCORS: true,
	});

	const img = new Image();
	img.src = canvas.toDataURL('image/jpeg', 1.0);
	await img.decode();

	img.style.width = '100%';
	img.style.display = 'block';
	el.appendChild(img);

	const orientation = img.height > img.width ? 'portrait' : 'landscape';
	const pdf = new jsPDF(orientation, 'px', [img.height, img.width]);
	pdf.addImage(canvas, 'JPEG', 0, 0, img.width, img.height, 'px', 'SLOW');
	pdf.save(filename);
	img.remove();
};

const GenerateCallReportPDFModal: FC<{
	modal: GenerateCallReportPDFModalState;
	onClose: () => void;
}> = ({ modal, onClose }) => {
	const { data } = useQuery({
		queryKey: [
			'getFRMCallReportDetailWithId',
			modal?.callReportId,
			modal?.prospectId,
		] as const,
		queryFn: ({ queryKey }) => {
			const [, id, prospectId] = queryKey;
			if (!id || !prospectId) return;
			return getFRMCallReportDetailWithId(String(id), prospectId);
		},
		enabled: Boolean(modal),
	});

	const handleOpenChange = (isOpen: boolean) => {
		if (!isOpen) return;
		const printArea = document.getElementById('call-report-pdf-content');
		if (!printArea) return;
		downloadPDF(printArea, `call-report-${Date.now()}.pdf`);
		onClose();
	};

	return (
		<FleetModal
			open={!!modal}
			width={'100%'}
			okButtonProps={{ hidden: true }}
			cancelButtonProps={{ hidden: true }}
			afterOpenChange={handleOpenChange}
			onCancel={() => onClose()}
		>
			{data?.data && (
				<CallReportPdfDetail data={data.data as CallReportPdfData} />
			)}
		</FleetModal>
	);
};

export type GenerateCallReportPDFModalState = null | {
	prospectId: string;
	callReportId: number;
};

export const useGenerateCallReportPDFModal = () => {
	return useState<GenerateCallReportPDFModalState>(null);
};

export default GenerateCallReportPDFModal;
